import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import frCommon from '../locales/fr/common.json';
import arCommon from '../locales/ar/common.json';

export const SUPPORTED_LANGUAGES = ['fr', 'ar'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      if (namespace === 'common') {
        return language === 'fr' ? frCommon : arCommon;
      }
      return import(`../locales/${language}/${namespace}.json`);
    })
  )
  .use(initReactI18next)
  .init({
    lng: 'fr',
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
  });

export default i18n;
